import React from 'react';
import { Download2Icon, DownloadExcelIcon } from 'assets/icons';
import { Globals } from 'utils';
import { Pagination, Input, Button, Select } from 'components';
import { GeneralService, ReportsService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

const INITIAL_STATE = {
  search: '',
  speciality: '',
  ci: '',
}

class ReportAppoinments extends React.Component {

  debounce?: NodeJS.Timeout;

  state = {
    form: INITIAL_STATE,
    data: [],
    specialties: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getSelects()
    this.load()
  }

  load = async (page: number = 1, download: boolean = false, paymentId?: number) => {
    try {

      let payload = { page, ...this.state.form, download } as any;
      if (paymentId) payload = { ...payload, id: paymentId };

      const res = await ReportsService.assignedAppoinments(payload)

      if (download) return res;

      const { data, ...rest } = res as any;
      this.setState({ data, pagination: rest });
    } catch (error) {
      console.log(error);
      const err = error as any;
      Globals.showError(err?.response?.data?.error ?? 'Ocurrió un error inesperado');
    }
  }

  getSelects = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];
    try {
      const specialities: any = await GeneralService.getSpecialties();
      this.setState({
        specialties: toSelect(specialities),
      });
    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  download = async (paymentId?: number) => {
    try {
      const res: any = await this.load(this.state.pagination.page, true, paymentId);
      if (!res?.url) return;

      const link = document.createElement('a');
      link.href = Globals.fromStorage(res?.url);
      link.download = 'reporte.xlsx';
      link.target = '_blank';
      link.click();

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof INITIAL_STATE) => {
    const form = Globals.clone(this.state.form);
    form[target] = value;
    await this.setState({ form });

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.load(1), 800);
  }


  cleanFilters = async () => {
    await this.setState({ form: { ...INITIAL_STATE } });
    this.load(1);
  }


  render() {
    const { form, specialties } = this.state
    const canCleanFilters = JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);

    return (
      <div id="report-appointment">
        <section className="filters">
          <Input
            label="Buscar"
            placeholder="Nombre del plan, empresa, paciente"
            className="large-input"
            value={form.search}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
          />

          <Select
            label="Especialidad"
            name="speciality"
            className="select-filter"
            value={form.speciality}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'speciality')}
            options={specialties}
          />

          <Input
            label="Cédula"
            placeholder="Cédula"
            value={form.ci}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'ci')}
          />

          {canCleanFilters && (
            <Button clear onClick={this.cleanFilters}>
              Limpiar
            </Button>
          )}
        </section>

        <div className="rg-table">
          <div className="rg-table-header">
            <p></p>
            <div className="rg-table-actions">
              <button onClick={() => this.download()}>
                <img src={Download2Icon} alt="Descargar" />
                <span>Descargar Excel</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Empresa compradora</th>
                <th>Plan utilizado</th>
                <th>Especialidad</th>
                <th>Nombre del paciente</th>
                <th>Cédula de identidad</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((appoinment: any, index: number) => {
                return <AppoinmentItem key={appoinment?.id} appoinment={appoinment} download={this.download} />
              })}
            </tbody>
          </table>

          {!this.state.data.length && (
            <div className='no-items'>
              <p>No se encontraron resultados</p>
            </div>
          )}
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.load}
        />
      </div>
    )
  }
}


const AppoinmentItem = ({ appoinment, download }: any) => {


  return (
    <tr>
      <td>{appoinment?.company?.company_name}</td>
      <td>{appoinment?.plan?.name}</td>
      <td>{appoinment?.specialty?.name}</td>
      <td>{appoinment?.user?.full_name}</td>
      <td>{appoinment?.user?.document}</td>
      <td className='actions'>
        <div>
          <img
            className='pointer'
            src={DownloadExcelIcon}
            alt="Descargar"
            title="Descargar"
            onClick={() => download(appoinment?.id)}
          />
        </div>
      </td>
    </tr>
  )
}

export default ReportAppoinments;